module.exports = __webpack_public_path__ + "static/media/plus.71b39990.svg";